module.exports = __webpack_public_path__ + "img/grass4.61b88e2d.png";